if (!customElements.get("sign-in-modal")) {
  customElements.define(
    "sign-in-modal",
    class SignInModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener("click", this.handleLinkClick.bind(this));
        document.addEventListener(
          "DOMContentLoaded",
          this.validateEmail(),
          this.validatePassword(),
          this.disableButton()
        );
        this.querySelector("form")?.addEventListener(
          "submit",
          this.handleSubmit.bind(this)
        );
      }

      // If there's a link, close all modal dialogs before the redirect
      handleLinkClick(event) {
        if (event.target.tagName === "A" && event.target.href) {
          super.hide();
        }
      }

      validateEmail() {
        const emailInput = document.querySelector('input[type="email"]');
        const emailErrorMsg = this.querySelector('.field__email .field__error-message');

        emailInput.addEventListener("blur", function () {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (emailInput.value === "") {
            emailInput.classList.add("field__input", "error");
            emailErrorMsg.style.display = 'block';
          } else if (!emailPattern.test(emailInput.value)) {
            emailInput.classList.add("field__input", "error");
            emailErrorMsg.style.display = 'block';
          } else {
            emailInput.classList.remove("field__input", "error");
            emailErrorMsg.style.display = 'none';
          }
        });
      }

      validatePassword() {
        const passwordInput = document.querySelector('input[type="password"]');
        const passwordLabel = this.querySelector('.field__password .field__label');
        const passwordErrorMsg = this.querySelector('.field__password .field__error-message');

        passwordInput.addEventListener("blur", function () {
          const passwordValue = passwordInput.value.trim();

          if (passwordValue === "") {
            passwordInput.classList.add("field__input", "error");
            if (passwordLabel) {
              passwordErrorMsg.style.display = 'block';
            }
          } else {
            passwordInput.classList.remove("field__input", "error");
            if (passwordLabel) {
              passwordErrorMsg.style.display = 'none';
            }
          }
        });
      }

      disableButton() {
        const ctaButton = document.querySelector(
          ".sign-in-modal__content-info .cta-button"
        );
        const passwordInput = document.querySelector('input[type="password"]');
        const emailInput = document.querySelector('input[type="email"]');

        function toggleButtonState() {
          if (
            emailInput.classList.contains("error") ||
            passwordInput.classList.contains("error")
          ) {
            ctaButton.classList.add("disabled");
            ctaButton.setAttribute("disabled", "true");
          } else {
            ctaButton.classList.remove("disabled");
            ctaButton.removeAttribute("disabled");
          }
        }

        emailInput.addEventListener("blur", toggleButtonState);
        passwordInput.addEventListener("blur", toggleButtonState);
      }

      hide() {
        super.hide();
        sessionStorage.removeItem("signInSource");
      }

      show(opener) {
        super.show(opener);
      }

      handleSubmit(event) {
        const signInSource = sessionStorage.getItem("signInSource");

        if (signInSource === "cart") {
          const form = event.target;
          const returnToInput = form.querySelector('input[name="return_to"]');

          if (returnToInput) {
            const url = new URL(returnToInput.value, window.location.origin);
            url.searchParams.set("cart", "open");
            returnToInput.value = url.pathname + url.search;
          }
          sessionStorage.removeItem("signInSource");
        }
      }
    }
  );
}
